import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';
import i18n from '@/shared/lib/i18n';

/**
 * Agenda knihovny placeholderů (seznam). Univerzální ListPage (engine `@/shared/ui/list-page`,
 * šablona `PlaceholderListPage.tsx`). Otevírá detail jako modální vrstvu.
 */
export const placeholderListAgenda = defineAgenda({
  id: 'app.venua-planner.placeholders',
  path: 'app/venua-planner/placeholders',
  open: {},
  state: listPageViewState,
  title: () => i18n.t('schemes.placeholderList.agendaTitle', { ns: 'venua-planner' }),
  icon: 'square-dashed',
});
